import { r as registerInstance, h, F as Fragment } from './index-e3eeb4ec.js';
import { L as Locale } from './index-6afae4e4.js';
import { g as getFormattedTime, l as getRoundedOffsetFromSeekableEnd, E as EVENTS, K as KEYBOARD_KEY_CODES, S as STATUS, a as SKIP_INCREMENT, I as INDICATORS } from './index-fd930a73.js';
const indexCss$8 = "progress.phx-buffer-bar{background:#808080;background-color:#808080}progress.phx-buffer-bar.hidden{display:none}progress.phx-buffer-bar::-moz-progress-bar{opacity:0.3;background:#fff}progress.phx-buffer-bar::-webkit-progress-value{opacity:0.3;background:#fff}progress.phx-buffer-bar::-ms-fill{opacity:0.3;background:#fff}";
const BufferBarStyle0 = indexCss$8;
const BufferBar = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.locale = Locale();
    this.onObserverUpdate = state => {
      this.isSeekable = state.isSeekable;
      this.bufferDataValue = state.bufferData.value;
      this.bufferDataMax = state.bufferData.max;
    };
  }
  connectedCallback() {
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
  }
  render() {
    const hideClass = this.isSeekable ? "" : " hidden";
    return h("progress", {
      key: 'f5803e9e20e8a5f8b31e5efc7b8d12e52051108e',
      class: `phx-buffer-bar${hideClass}`,
      value: this.bufferDataValue,
      max: this.bufferDataMax,
      "aria-valuemax": this.bufferDataMax,
      "aria-label": this.locale.buffered,
      "aria-live": "off"
    });
  }
};
BufferBar.style = BufferBarStyle0;
const indexCss$7 = ".phx-current-time-metadata{color:#fff;text-shadow:0 0 2px rgba(0, 0, 0, 0.5);opacity:0.9}";
const CurrenttimeMetadataStyle0 = indexCss$7;
const CurrentTime = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onObserverUpdate = state => {
      this.currentTime = state.currentTime;
      this.isSeekable = state.isSeekable;
      this.duration = state.duration;
      this.isAtLiveEdge = state.isAtLiveEdge;
      this.liveSyncPosition = state.liveSyncPosition;
    };
  }
  connectedCallback() {
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
  }
  render() {
    if (!this.isSeekable) return;
    let time = this.currentTime;
    if (this.duration === Infinity) {
      if (this.isAtLiveEdge || this.liveSyncPosition === Infinity) return;
      time = getRoundedOffsetFromSeekableEnd(this.currentTime, this.liveSyncPosition);
    }
    const displayedTime = getFormattedTime(time);
    return h("span", {
      class: "phx-current-time-metadata"
    }, displayedTime);
  }
};
CurrentTime.style = CurrenttimeMetadataStyle0;
const indexCss$6 = ".phx-duration-metadata{color:#fff;text-shadow:0 0 2px rgba(0, 0, 0, 0.5);opacity:0.9}";
const DurationMetadataStyle0 = indexCss$6;
const Duration = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onObserverUpdate = state => {
      this.isSeekable = state.isSeekable;
      this.duration = state.duration;
    };
    this.isValidDuration = duration => {
      return duration && duration !== Infinity && !Number.isNaN(duration);
    };
  }
  connectedCallback() {
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
  }
  render() {
    if (!this.isSeekable || !this.isValidDuration(this.duration)) return;
    const formattedDuration = getFormattedTime(this.duration);
    return h("span", {
      class: "phx-duration-metadata"
    }, formattedDuration);
  }
};
Duration.style = DurationMetadataStyle0;
const indexCss$5 = ".phx-muted-btn.audio svg{width:100%;height:100%}.phx-muted-btn.audio svg .background{fill:rgba(255, 255, 255, 0.85)}.phx-muted-btn.audio svg .foreground{fill:#000}.phx-muted-btn.audio label{display:none}";
const MutedBtnStyle0 = indexCss$5;
const MutedBtn = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.locale = Locale();
    this.onInitPlay = () => {
      this.isMuted = this.publicAPI.media.getMuted();
    };
    this.onMutedChange = isMuted => {
      this.isMuted = isMuted;
    };
    this.onVolumeChange = volume => {
      this.isNoVolume = volume === 0;
    };
    this.renderUnmute = isVideo => {
      return h("button", {
        type: "button",
        "aria-label": this.locale.unmute,
        "data-mute": "false",
        class: `phx-muted-btn ${isVideo ? "video" : "audio"}`
      }, h("svg", {
        focusable: "false",
        role: "presentation",
        viewBox: "0 0 24 24"
      }, h("path", {
        class: "foreground",
        d: "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
      })), h("label", {
        class: "phx-tooltip"
      }, this.locale.unmute));
    };
    this.getVolumePath = () => {
      const withNoSoundWaves = h("path", {
        class: "foreground novolume",
        d: "M 3 9 L 3 15 L 7 15 L 12 20 L 12 4 L 7 9 L 3 9 Z"
      });
      const withSoundWaves = h("path", {
        class: "foreground",
        d: "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
      });
      return this.isNoVolume ? withNoSoundWaves : withSoundWaves;
    };
    this.renderMute = isVideo => {
      return h("button", {
        type: "button",
        "aria-label": this.locale.mute,
        "data-mute": "true",
        class: `phx-muted-btn ${isVideo ? "video" : "audio"}`
      }, h("svg", {
        focusable: "false",
        role: "presentation",
        viewBox: "0 0 24 24"
      }, h("path", {
        class: "background",
        d: "M0 0h24v24H0z"
      }), this.getVolumePath()), h("label", {
        class: "phx-tooltip"
      }, this.locale.mute));
    };
  }
  handleClick(e) {
    var _a;
    const button = e.target.closest("button");
    const action = button.dataset.mute === "true";
    (_a = this.publicAPI.media) === null || _a === void 0 ? void 0 : _a.setMuted(action);
    this.publicAPI.userInteractionsObserver.notifySubscribers({
      interactionOwner: "muted-btn",
      interactionName: `volume-${action ? "mute" : "unmute"}`,
      interactionType: "PointerEvent"
    });
  }
  connectedCallback() {
    this.isMuted = this.publicAPI.media.getMuted();
    this.publicAPI.on(EVENTS.PLAYBACK_INITIALPLAY, this.onInitPlay);
    this.publicAPI.on(EVENTS.PLAYBACK_MUTEDCHANGE, this.onMutedChange);
    this.publicAPI.on(EVENTS.PLAYBACK_VOLUMECHANGE, this.onVolumeChange);
  }
  disconnectedCallback() {
    this.publicAPI.off(EVENTS.PLAYBACK_INITIALPLAY, this.onInitPlay);
    this.publicAPI.off(EVENTS.PLAYBACK_MUTEDCHANGE, this.onMutedChange);
    this.publicAPI.off(EVENTS.PLAYBACK_VOLUMECHANGE, this.onVolumeChange);
  }
  render() {
    var _a, _b;
    const isVideo = ((_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData) === null || _b === void 0 ? void 0 : _b.format) !== "audio";
    return this.isMuted ? this.renderUnmute(isVideo) : this.renderMute(isVideo);
  }
};
MutedBtn.style = MutedBtnStyle0;
const indexCss$4 = "@charset \"UTF-8\";\n/* accessibility class visually hides content but keeps it available for Assistive Tech users */\n.phx-options-menu {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  max-width: 286px;\n  min-width: 286px;\n  bottom: 60px;\n  right: 2%;\n  max-height: 280px;\n}\n.phx-options-menu *,\n.phx-options-menu *:before,\n.phx-options-menu *:after {\n  box-sizing: border-box;\n}\n.phx-options-menu .phx-options-menu-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border: solid 1px #585858;\n  border-radius: 8px;\n  background-color: #000000;\n  color: white;\n  font-family: sans-serif;\n  font-size: 0.8rem;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-shadow: rgba(0, 0, 0, 0.01) 0 0 1px;\n  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n  overflow: auto;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menulist {\n  list-style: none;\n  margin: 0;\n  padding: 0 0 8px 0;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menulist.main-menu {\n  padding: 8px 0;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menulist.main-menu > .phx-options-menulist-item {\n  padding: 8px 0;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menulist.main-menu > .phx-options-menulist-item > .phx-options-menulist-item-label {\n  flex: 80%;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menulist > .phx-options-menulist-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0;\n  cursor: pointer;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menulist > .phx-options-menulist-item > .phx-options-menulist-item-label {\n  flex: 100%;\n  font-weight: 400;\n  margin-left: 12px;\n  pointer-events: none;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menulist > .phx-options-menulist-item > .phx-options-menulist-item-label.main-menu {\n  font-weight: 700;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menulist > .phx-options-menulist-item > .phx-options-menulist-selection {\n  display: flex;\n  align-items: center;\n  font-size: 0.688rem;\n  font-weight: 400;\n  margin-right: 8px;\n  flex: 100%;\n  justify-content: flex-end;\n  pointer-events: none;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menulist > .phx-options-menulist-item:hover {\n  background-color: #353535;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menulist > .phx-options-menulist-item:focus, .phx-options-menu .phx-options-menu-content .phx-options-menulist > .phx-options-menulist-item:focus-within {\n  outline: 2px solid #EE0000;\n  outline-offset: -1px;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menulist > .phx-options-menulist-item[aria-checked]:before {\n  content: \"•\";\n  font-weight: 700;\n  margin-left: 12px;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menulist > .phx-options-menulist-item[aria-checked] .phx-options-menulist-item-label {\n  font-weight: 700;\n  margin-left: 5px;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menu-cta {\n  position: relative;\n  top: -8px;\n  padding: 8px 12px 0 12px;\n  border-top: 1px solid #585858;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menu-cta span a, .phx-options-menu .phx-options-menu-content .phx-options-menu-cta span a:visited {\n  color: white;\n  font-weight: 700;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menu-cta span a:hover {\n  text-decoration: none;\n}\n.phx-options-menu .phx-options-menu-content .phx-options-menu-cta span a:focus-visible {\n  outline: none;\n  border: 2px solid #e60606;\n}\n\n@media (max-width: 420px) {\n  .phx-options-menu {\n    max-height: 115px;\n  }\n}\n@container phoenix-player (max-width: 420px) {\n  .phx-options-menu {\n    max-height: 115px;\n  }\n}\n@container phoenix-player (min-width: 421px) and (max-width: 640px) {\n  .phx-options-menu {\n    max-height: 180px;\n  }\n}";
const OptionsMenuStyle0 = indexCss$4;
const OptionsMenu = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.notifySubscribers = () => {
      this.publicAPI.userInteractionsObserver.notifySubscribers({
        interactionOwner: "options-menu",
        interactionName: "",
        interactionType: "click"
      });
    };
    this.renderMenuItems = () => {
      var _a;
      const isSubmenu = !!((_a = this.menuConfig) === null || _a === void 0 ? void 0 : _a.title);
      return h(Fragment, null, isSubmenu && h("options-menu-back-btn", {
        menuTitle: this.menuConfig.title,
        publicAPI: this.publicAPI
      }), h("ul", {
        class: `phx-options-menulist ${!isSubmenu ? "main-menu" : ""}`,
        role: "menu"
      }, this.menuConfig.items.map((item, index) => {
        return h("li", {
          class: `phx-options-menulist-item ${!this.ctaConfig && index === this.menuConfig.items.length - 1 ? "last-item" : ""}`,
          role: "menuitemradio",
          "aria-checked": item.selected,
          "data-value": item.id,
          "data-name": item.name,
          tabindex: "0"
        }, h("span", {
          class: `phx-options-menulist-item-label ${!isSubmenu ? "main-menu" : ""}`
        }, item.name), !isSubmenu && h("span", {
          class: "phx-options-menulist-selection"
        }, item.currentSelection, h("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          focusable: "false",
          role: "presentation",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, h("path", {
          d: "M9.30996 6.71002C8.91996 7.10002 8.91996 7.73002 9.30996 8.12002L13.19 12L9.30996 15.88C8.91996 16.27 8.91996 16.9 9.30996 17.29C9.69996 17.68 10.33 17.68 10.72 17.29L15.31 12.7C15.7 12.31 15.7 11.68 15.31 11.29L10.72 6.70002C10.34 6.32002 9.69996 6.32002 9.30996 6.71002Z",
          fill: "white"
        }))));
      })));
    };
    this.renderCTA = () => {
      var _a, _b;
      if (!this.ctaConfig) return null;
      return h("div", {
        class: "phx-options-menu-cta"
      }, h("span", null, (_a = this.ctaConfig.textBefore) !== null && _a !== void 0 ? _a : "", h("a", {
        href: this.ctaConfig.linkUrl,
        class: "last-item",
        target: "_blank"
      }, this.ctaConfig.linkText), (_b = this.ctaConfig.textAfter) !== null && _b !== void 0 ? _b : ""));
    };
  }
  handleClick(event) {
    // prevents clicks from bubble and reach other components
    event.stopPropagation();
    const target = event.target;
    if (target.tagName.toLowerCase() === "li") {
      this.menuConfig.onChange(target.getAttribute("data-value"));
      this.notifySubscribers();
    }
  }
  handleKeyDown(event) {
    if (event.code === KEYBOARD_KEY_CODES.ENTER || event.code === KEYBOARD_KEY_CODES.SPACE) {
      const target = event.target;
      if (target.tagName.toLowerCase() === "li") {
        this.menuConfig.onChange(target.getAttribute("data-value"));
        this.notifySubscribers();
      }
    }
  }
  render() {
    var _a, _b;
    if (!((_b = (_a = this.menuConfig) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length)) return null;
    return h("div", {
      class: "phx-options-menu"
    }, h("div", {
      class: "phx-options-menu-content"
    }, this.renderMenuItems(), this.renderCTA()));
  }
};
OptionsMenu.style = OptionsMenuStyle0;
const locale = Locale();
const renderAudioPause = () => {
  return h(Fragment, null, h("svg", {
    class: "audio-pause-svg",
    viewBox: "0 0 60 60"
  }, h("circle", {
    fill: "#FFFFFF",
    stroke: "#CBCBCB",
    "stroke-width": "2",
    cx: "30",
    cy: "30",
    r: "28"
  }), h("path", {
    d: "M26 21.5 L26 38.5",
    "stroke-width": "4",
    stroke: "#000000",
    "stroke-linecap": "round"
  }), h("path", {
    d: "M34 21.5 L34 38.5",
    "stroke-width": "4",
    stroke: "#000000",
    "stroke-linecap": "round"
  })), h("label", {
    class: "phx-tooltip"
  }, "Pause"));
};
const renderVideoPause = () => {
  return h(Fragment, null, h("svg", {
    class: "video-pause-svg",
    focusable: "false",
    role: "presentation",
    viewBox: "0 0 24 24"
  }, h("path", {
    class: "foreground",
    d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
  })), h("label", {
    class: "phx-tooltip"
  }, locale.pause));
};
const renderAudioPlay = () => {
  return h(Fragment, null, h("svg", {
    class: "audio-play-svg",
    viewBox: "0 0 60 60",
    focusable: "false",
    role: "presentation"
  }, h("circle", {
    "stroke-width": "2px",
    stroke: "#CBCBCB",
    fill: "#FFFFFF",
    cx: "30",
    cy: "30",
    r: "28"
  }), h("polygon", {
    fill: "#000000",
    points: "43 30 23 20 23 40"
  })), h("label", {
    class: "phx-tooltip"
  }, locale.play));
};
const renderVideoPlay = () => {
  return h(Fragment, null, h("svg", {
    class: "video-play-svg",
    focusable: "false",
    role: "presentation",
    viewBox: "0 0 24 24"
  }, h("path", {
    class: "background",
    d: "M0 0h24v24H0z"
  }), h("path", {
    class: "foreground",
    d: "M8 5v14l11-7z"
  })), h("label", {
    class: "phx-tooltip"
  }, locale.play));
};
const renderAudioStop = () => {
  return h(Fragment, null, h("svg", {
    class: "audio-stop-svg",
    viewBox: "0 0 60 60",
    focusable: "false",
    "aria-label": locale.stop
  }, h("circle", {
    "stroke-width": "2px",
    stroke: "#CBCBCB",
    fill: "#FFFFFF",
    cx: "30",
    cy: "30",
    r: "28"
  }), h("rect", {
    height: "18",
    width: "18",
    y: "21",
    x: "21"
  })), h("label", {
    class: "phx-tooltip"
  }, locale.stop));
};
const renderVideoStop = () => {
  return h(Fragment, null, h("svg", {
    class: "video-stop-svg",
    height: "100%",
    width: "100%",
    viewBox: "0 0 80 80",
    focusable: "false",
    role: "presentation"
  }, h("path", {
    class: "background",
    d: "m0 0v80h80v-80h-80zm22 20h36v40h-36v-40z"
  }), h("rect", {
    class: "foreground",
    "fill-rule": "evenodd",
    height: "40",
    width: "36",
    y: "20",
    x: "22"
  })), h("label", {
    class: "phx-tooltip"
  }, locale.stop));
};
const renderPause = format => {
  return h("button", {
    type: "button",
    class: "phx-pause-btn"
  }, format === "audio" ? renderAudioPause() : renderVideoPause());
};
const renderPlay = format => {
  return h("button", {
    type: "button",
    class: "phx-play-btn"
  }, format === "audio" ? renderAudioPlay() : renderVideoPlay());
};
const renderStop = (format, isMediaLoading) => {
  const mediaLoadingClass = isMediaLoading ? " media-loading" : "";
  return h("button", {
    type: "button",
    class: `phx-stop-btn${mediaLoadingClass}`
  }, format === "audio" ? renderAudioStop() : renderVideoStop());
};
const PlayPauseStopBtn = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onObserverUpdate = state => {
      this.isSeekable = state.isSeekable;
      this.playerStatus = state.status.to;
      this.isMediaLoading = state.isMediaLoading;
    };
  }
  connectedCallback() {
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
  }
  getBtnBasedOnStatus(format) {
    switch (this.playerStatus) {
      case STATUS.LOADING:
      case STATUS.PLAYING:
        if (this.isSeekable === true) {
          return renderPause(format);
        } else {
          return renderStop(format, this.isMediaLoading);
        }
      case STATUS.ADVERTISING:
        return renderPause(format);
      default:
        return renderPlay(format);
    }
  }
  handleClick() {
    let interactionName = "play";
    switch (this.playerStatus) {
      case STATUS.LOADING:
      case STATUS.PLAYING:
        if (this.isMediaLoading && this.publicAPI.mediaData.format === "audio") return;
        this.isSeekable ? this.publicAPI.media.pause() : this.publicAPI.media.stop();
        interactionName = this.isSeekable ? "pause" : "stop";
        break;
      case STATUS.ADVERTISING:
        this.publicAPI.media.pause();
        interactionName = "pause";
        break;
      default:
        this.publicAPI.media.play();
    }
    this.publicAPI.userInteractionsObserver.notifySubscribers({
      interactionOwner: "play-pause-stop-btn",
      interactionName,
      interactionType: "click"
    });
  }
  render() {
    const format = this.publicAPI.mediaData.format;
    return this.getBtnBasedOnStatus(format);
  }
};
const indexCss$3 = "div.phx-controls-seek{bottom:26px;pointer-events:auto}div.phx-controls-seek.hidden{display:none}div.phx-controls-seek>.phx-controls-seek-inner{position:relative;height:4px;transition:height 0.2s}div.phx-controls-seek>.phx-controls-seek-inner progress,div.phx-controls-seek>.phx-controls-seek-inner input{position:absolute;top:0;left:0;width:100%;height:100%;margin:0;padding:0}div.phx-controls-seek:focus-within>.phx-controls-seek-inner{height:6px}div.phx-controls-seek:focus-within>.phx-controls-seek-inner input[type=range]::-ms-thumb{width:14px;height:14px}div.phx-controls-seek:focus-within>.phx-controls-seek-inner input[type=range]::-webkit-slider-thumb{width:14px;height:14px}div.phx-controls-seek:focus-within>.phx-controls-seek-inner input[type=range]::-moz-range-thumb{width:14px;height:14px}div.phx-controls-seek:hover>.phx-controls-seek-inner{height:6px}div.phx-controls-seek:hover>.phx-controls-seek-inner input[type=range]::-ms-thumb{width:14px;height:14px}div.phx-controls-seek:hover>.phx-controls-seek-inner input[type=range]::-webkit-slider-thumb{width:14px;height:14px}div.phx-controls-seek:hover>.phx-controls-seek-inner input[type=range]::-moz-range-thumb{width:14px;height:14px}div.phx-controls-seek progress,div.phx-controls-seek input[type=range]{border:none;-moz-appearance:none;-webkit-appearance:none;appearance:none}div.phx-controls-seek progress.barber-pole{display:block;opacity:1;background:repeating-linear-gradient(45deg, rgba(71, 89, 99, 0.5), rgba(71, 89, 99, 0.5) 10px, #576d7b 10px, #576d7b 20px);animation:animatedbuffer 1s linear infinite}div.phx-controls-seek progress.barber-pole::-webkit-progress-bar{background:none}div.phx-controls-seek progress.barber-pole::-webkit-progress-value{background:none}div.phx-controls-seek progress.barber-pole::-moz-progress-bar{background:none}div.phx-controls-seek progress.barber-pole::-ms-fill{background:none;animation-name:none}@keyframes animatedbuffer{from{background-position-x:-56px;background-size:150%}to{background-position-x:0px;background-size:150%}}div.phx-controls-seek progress.barber-pole.animation-paused{animation:none}div.phx-controls-seek.audio{position:unset;width:unset;min-height:10px;padding:12px 0}";
const SeekBarStyle0 = indexCss$3;
const SeekBar = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.playerStatus = null;
    this.onObserverUpdate = state => {
      var _a;
      this.isSeekable = state.isSeekable;
      this.playerStatus = (_a = state.status) === null || _a === void 0 ? void 0 : _a.to;
      this.isClientSideAdvertising = state.isClientSideAdvertising;
    };
    this.checkIfVisible = isVideo => {
      if (this.isClientSideAdvertising) return false;
      return isVideo ? this.playerStatus !== STATUS.READY && this.playerStatus !== STATUS.ERROR : true;
    };
  }
  connectedCallback() {
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
  }
  render() {
    var _a, _b;
    const isVideo = ((_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData) === null || _b === void 0 ? void 0 : _b.format) !== "audio";
    const hideClass = this.checkIfVisible(isVideo) ? "" : " hidden";
    const isAudioReady = !isVideo && (!this.playerStatus || this.playerStatus === STATUS.READY);
    return h("div", {
      key: '794689510d7926747e5c8b1502152e39d6edb4d9',
      class: `phx-controls-seek${hideClass} ${isVideo ? "video" : "audio"}`
    }, h("div", {
      key: 'fb3f5bb5fa04fa740a7771287d61080cc79fab7d',
      class: "phx-controls-seek-inner"
    }, h("buffer-bar", {
      key: '8c4fdb061b43e63e5a3673e3f9a8b8d1bc3b9ff8',
      publicAPI: this.publicAPI
    }), h("seek-input", {
      key: '5575bf54701ad8d14271af12b689d3d5b268aca4',
      publicAPI: this.publicAPI
    }), !this.isSeekable ? h("progress", {
      class: `barber-pole ${isAudioReady ? "animation-paused" : ""}`
    }) : null));
  }
};
SeekBar.style = SeekBarStyle0;
const indexCss$2 = "progress.playback,input.phx-seek-input{background:none}progress.playback{color:#E60606}progress.playback::-moz-progress-bar{background:#E60606}progress.playback::-webkit-progress-bar{background-color:transparent}progress.playback::-webkit-progress-value{background:#E60606}progress.playback::-ms-fill{background:#E60606}input.phx-seek-input{cursor:pointer;background:linear-gradient(to right, red var(--seek-position, 0%), transparent var(--seek-position, 0%))}input.phx-seek-input.hidden{display:none}input.phx-seek-input::-webkit-slider-runnable-track{-webkit-appearance:none;border:none;background:transparent;background-color:transparent;color:transparent}input.phx-seek-input::-moz-range-track{border:none;background:transparent;background-color:transparent;color:transparent}input.phx-seek-input::-ms-track,input.phx-seek-input::-ms-fill-upper,input.phx-seek-input::-ms-fill-lower{border:none;background:transparent;background-color:transparent;color:transparent}input.phx-seek-input::-ms-thumb{background:#E60606;border:none;border-radius:50%;width:4px;height:4px;transform:translateX(-4px);transition:width 0.2s, height 0.2s}input.phx-seek-input::-webkit-slider-thumb{-webkit-appearance:none;background:#E60606;border:none;border-radius:50%;width:4px;height:4px;transform:translateX(-4px);transition:width 0.2s, height 0.2s}input.phx-seek-input::-moz-range-thumb{background:#E60606;border:none;border-radius:50%;width:4px;height:4px;transform:translateX(-4px);transition:width 0.2s, height 0.2s}input.phx-seek-input:focus{outline:2px solid #E60606}input.phx-seek-input:focus::-moz-focus-inner{border:0}input.phx-seek-input:focus::-moz-focus-outer{border:0}output{position:absolute;display:none;top:-38px;width:auto;height:auto;left:var(--tooltipLeftPosition);padding:6px;border-radius:4px;background:#263238;font-size:0.6875rem;font-weight:bold;color:#fff;white-space:nowrap;pointer-events:none;line-height:1rem}output.hidden{display:none}input.phx-seek-input:hover+output{display:block}";
const SeekInputStyle0 = indexCss$2;
const SeekInput = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.timeTooltipValues = {
      value: "",
      leftPosition: ""
    };
    this.locale = Locale();
    this.onObserverUpdate = state => {
      this.currentTime = state.currentTime;
      this.isSeekable = state.isSeekable;
      this.seekableRangeStart = state.seekableRange.start;
      this.seekableRangeEnd = state.seekableRange.end;
    };
    this.dispatchInteraction = (type, name) => {
      this.publicAPI.userInteractionsObserver.notifySubscribers({
        interactionOwner: "seek-input",
        interactionName: name,
        interactionType: type
      });
    };
    this.updateTooltip = event => {
      var _a, _b, _c, _d;
      const target = event.target;
      const style = window.getComputedStyle(target, null);
      const rect = target.getBoundingClientRect();
      const borderLeftWidth = parseInt(style["borderLeftWidth"]);
      let clientX = event.clientX;
      const touchEvent = event;
      if ((_a = touchEvent === null || touchEvent === void 0 ? void 0 : touchEvent.touches) === null || _a === void 0 ? void 0 : _a[0]) {
        clientX = touchEvent.touches[0].clientX;
      }
      if (!clientX) return;
      const offsetX = clientX - borderLeftWidth - rect.left;
      const percentValue = offsetX / rect.width;
      const inputMaxValue = parseInt((_b = this.inputElement) === null || _b === void 0 ? void 0 : _b.getAttribute("max"));
      let timeValue = Math.ceil(inputMaxValue * percentValue);
      timeValue = Math.max(0, Math.min(inputMaxValue, timeValue));
      const outputElementWidth = (_c = this.outputElement) === null || _c === void 0 ? void 0 : _c.offsetWidth;
      const leftPos = offsetX - outputElementWidth / 2;
      this.timeTooltipValues = {
        value: getFormattedTime(timeValue),
        leftPosition: Math.max(0, Math.min(leftPos, rect.width - ((_d = this.outputElement) === null || _d === void 0 ? void 0 : _d.offsetWidth))) + "px"
      };
    };
    this.onKeydown = event => {
      if (event.code !== KEYBOARD_KEY_CODES.ARROWLEFT && event.code !== KEYBOARD_KEY_CODES.ARROWRIGHT) return;
      const seekAmount = event.code === KEYBOARD_KEY_CODES.ARROWLEFT ? -SKIP_INCREMENT : SKIP_INCREMENT;
      const newCurrentTime = seekAmount + this.publicAPI.media.getCurrentTime();
      const interactionName = seekAmount > 0 ? INDICATORS.SKIP_FORWARD : INDICATORS.SKIP_BACKWARD;
      this.publicAPI.media.setCurrentTime(newCurrentTime);
      this.dispatchInteraction("KeyboardEvent", interactionName);
    };
    this.enabledEventListeners = (enabled, inputElement) => {
      if (!inputElement) return;
      const method = enabled ? "addEventListener" : "removeEventListener";
      inputElement[method]("input", this.onInputChange);
      inputElement[method]("click", this.onInputChange);
      inputElement[method]("change", this.onInputChange);
      inputElement[method]("mousemove", this.updateTooltip);
      inputElement[method]("touchmove", this.updateTooltip);
      inputElement[method]("keydown", this.onKeydown);
    };
    this.onInputChange = event => {
      var _a;
      const newCurrentTime = parseInt(event.target.value);
      if (newCurrentTime === this.currentTime) return;
      const interactionName = newCurrentTime > this.currentTime ? INDICATORS.SKIP_FORWARD : INDICATORS.SKIP_BACKWARD;
      (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.media.setCurrentTime(newCurrentTime);
      this.dispatchInteraction("PointerEvent", interactionName);
    };
    this.getRef = el => {
      if (!el) this.enabledEventListeners(false, this.inputElement);
      this.inputElement = el;
      if (this.inputElement) this.enabledEventListeners(true, this.inputElement);
    };
  }
  connectedCallback() {
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
    this.enabledEventListeners(true, this.inputElement);
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
    this.enabledEventListeners(false, this.inputElement);
  }
  getCurrentTimePercentage() {
    const timeFromStart = this.currentTime - this.seekableRangeStart;
    const duration = this.seekableRangeEnd - this.seekableRangeStart;
    const percent = Math.min(100, Math.round(timeFromStart / duration * 100));
    return `${percent}%`;
  }
  render() {
    var _a;
    const hideClass = this.isSeekable ? "" : " hidden";
    const id = `seekbar-${(_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.uid}`;
    return h(Fragment, {
      key: 'a832670f8304917c55dd67791f129d38ff82abac'
    }, h("input", {
      key: 'd8f7c2383fece13a735b012f3be08a34fa6d0f0d',
      style: {
        "--seek-position": this.getCurrentTimePercentage()
      },
      id: id,
      ref: this.getRef,
      class: `phx-seek-input${hideClass}`,
      type: "range",
      min: this.seekableRangeStart,
      max: this.seekableRangeEnd,
      value: this.currentTime,
      "aria-label": this.locale.seekBar,
      "aria-valuenow": this.currentTime,
      "aria-valuemin": "0",
      "aria-valuemax": this.seekableRangeEnd,
      "aria-orientation": "horizontal"
    }), h("output", {
      key: '657d966381dd88ce17bfe64390a083e5fd7605ba',
      class: `time-tooltip${hideClass}`,
      style: {
        "--tooltipLeftPosition": this.timeTooltipValues.leftPosition
      },
      ref: el => this.outputElement = el,
      htmlFor: id
    }, this.timeTooltipValues.value));
  }
};
SeekInput.style = SeekInputStyle0;
const indexCss$1 = ".phx-volume-controls{display:inline-block}";
const VolumeControlsStyle0 = indexCss$1;
const VolumeControls = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  handleVolumeVisible() {
    this.sliderVisible = true;
  }
  handleVolumeNotVisible() {
    this.sliderVisible = false;
  }
  render() {
    return h("div", {
      key: 'ba0ef75aba6d1fcf4346590334e788c0eb2fa012',
      class: "phx-volume-controls"
    }, h("muted-btn", {
      key: 'eec7d9f36d85c334e4a076a1c1a8b3f40d5fdad5',
      publicAPI: this.publicAPI
    }), h("volume-slider", {
      key: '862dc0add7b6dc7d9479b29050a5557b51924b41',
      publicAPI: this.publicAPI,
      visibleByParent: this.sliderVisible
    }));
  }
};
VolumeControls.style = VolumeControlsStyle0;
const indexCss = ".phx-volume-slider{display:inline-block;overflow:hidden;width:0;height:30px;line-height:28px;-webkit-transition:margin 0.2s cubic-bezier(0.4, 0, 1, 1), width 0.2s cubic-bezier(0.4, 0, 1, 1);transition:margin 0.2s cubic-bezier(0.4, 0, 1, 1), width 0.2s cubic-bezier(0.4, 0, 1, 1);cursor:pointer;outline:0;border:2px solid transparent}@media (hover: none){.phx-volume-slider{display:none}}.phx-volume-slider.visible{width:56px}.phx-volume-slider.visible:focus-within{border:2px solid #E60606}.phx-volume-slider input{width:52px;margin:0px 2px;cursor:pointer;-webkit-appearance:none;-moz-apperance:none;-ms-appearance:none;border-radius:6px;height:6px;background:linear-gradient(to right, #FFFFFF 0%, #FFFFFF var(--currentVolume), #1c1c1c var(--currentVolume), #1c1c1c 100%)}.phx-volume-slider input:focus{outline:none}.phx-volume-slider input::-webkit-slider-thumb{-webkit-appearance:none;background-color:#FFFFFF;border-radius:50%;height:10px;width:10px;cursor:pointer}.phx-volume-slider input::-moz-range-thumb{-moz-apperance:none;background-color:#FFFFFF;border-radius:50%;height:10px;width:10px;cursor:pointer}.phx-volume-slider input::-ms-thumb{-ms-appearance:none;background-color:#FFFFFF;border-radius:50%;height:10px;width:10px;cursor:pointer}.phx-volume-slider input:focus+label{animation:tooltipAnimation 4s;z-index:1;color:white}@keyframes tooltipAnimation{0%{opacity:0;transform:translateY(-40px)}5%{opacity:1;transform:translateY(-70px)}95%{opacity:1;transform:translateY(-70px)}100%{opacity:0;transform:translateY(-40px)}}.phx-volume-slider label{line-height:normal;display:block;position:absolute;bottom:calc(-0.6875rem + -6px);padding:6px;border-radius:4px;background:#263238;font-size:0.6875rem;font-weight:bold;white-space:nowrap;transform:translateY(0px);opacity:0;pointer-events:none;line-height:1rem}.phx-volume-slider:hover label{animation:tooltipAnimation 4s;z-index:1;color:white}@keyframes tooltipAnimation{0%{opacity:0;transform:translateY(-40px)}5%{opacity:1;transform:translateY(-70px)}95%{opacity:1;transform:translateY(-70px)}100%{opacity:0;transform:translateY(-40px)}}.phx-volume-slider.audio.visible{width:100px}.phx-volume-slider.audio input{width:100px;background:linear-gradient(to right, #000000 0%, #000000 var(--currentVolume), #cbcbcb var(--currentVolume), #cbcbcb 100%);-webkit-appearance:none;-moz-apperance:none;-ms-appearance:none;border-radius:6px;height:6px;background-image:-webkit-gradient(linear, left top, right top, color-stop(0.15, #000000), color-stop(0.15, track-color))}.phx-volume-slider.audio input:focus{outline-style:dotted;outline-width:1px;outline-color:#000000}.phx-volume-slider.audio input::-webkit-slider-thumb{-webkit-appearance:none;background-color:#ffffff;border:1px solid #cbcbcb;border-radius:50%;height:12px;width:12px;cursor:pointer}.phx-volume-slider.audio input::-moz-range-thumb{-moz-apperance:none;background-color:#ffffff;border:1px solid #cbcbcb;border-radius:50%;height:12px;width:12px;cursor:pointer}.phx-volume-slider.audio input::-ms-thumb{-ms-appearance:none;background-color:#ffffff;border:1px solid #cbcbcb;border-radius:50%;height:12px;width:12px;cursor:pointer}";
const VolumeSliderStyle0 = indexCss;
const VolumeSlider = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.volume = 1;
    this.locale = Locale();
    this.onVolumeSliderChange = e => {
      const target = e.target;
      const newVolume = parseInt(target.value) / 10;
      this.publicAPI.media.setVolume(newVolume);
      this.publicAPI.media.setMuted(false);
      if (this.volume === newVolume) return;
      this.publicAPI.userInteractionsObserver.notifySubscribers({
        interactionOwner: "volume-slider",
        interactionName: `menu-${newVolume > this.volume ? "up" : "down"}`,
        interactionType: "InputEvent"
      });
    };
    this.onObserverUpdate = state => {
      this.volume = state.volume;
    };
    this.onInitialPlay = () => {
      this.volume = this.publicAPI.media.getVolume();
      this.publicAPI.off(EVENTS.PLAYBACK_INITIALPLAY, this.onInitialPlay);
    };
  }
  connectedCallback() {
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
  }
  render() {
    var _a, _b, _c;
    const isVideo = ((_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData) === null || _b === void 0 ? void 0 : _b.format) !== "audio";
    const id = `phx-volume-slider-${(_c = this.publicAPI) === null || _c === void 0 ? void 0 : _c.uid}`;
    return h("div", {
      key: '10e79de0e7d4a420c027956e1aff9d2775691726',
      class: `phx-volume-slider ${this.visibleByParent ? " visible" : ""} ${isVideo ? "video" : "audio"}`
    }, h("input", {
      key: 'dc29c92deabf1a4eb8d0724e39c9823dda8bd7c3',
      id: id,
      style: {
        "--currentVolume": this.volume * 100 + "%"
      },
      onInput: this.onVolumeSliderChange,
      type: "range",
      max: "10",
      "aria-valuemin": "0",
      "aria-valuemax": "10",
      "aria-orientation": "horizontal",
      "aria-valuenow": this.volume * 10,
      value: this.volume * 10
    }), h("label", {
      key: '60b773a19077d8f036aad3eed46e7bf518bff433',
      htmlFor: id,
      class: "phx-tooltip"
    }, this.locale.volumeLevel));
  }
};
VolumeSlider.style = VolumeSliderStyle0;
export { BufferBar as buffer_bar, CurrentTime as currenttime_metadata, Duration as duration_metadata, MutedBtn as muted_btn, OptionsMenu as options_menu, PlayPauseStopBtn as play_pause_stop_btn, SeekBar as seek_bar, SeekInput as seek_input, VolumeControls as volume_controls, VolumeSlider as volume_slider };